let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kmFdR")).then(() => parcelRequire('8KJda'));